import { SVGProps } from "react";

type SvgProps = SVGProps<SVGSVGElement>;

export const Corporate = (props: SvgProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6546_26235)">
      <path
        d="M6.25 8.58333H7.82325C7.44583 8.88608 7.15008 9.28567 6.985 9.75H6.25V8.58333ZM15 10.625V15H8V10.625C8 9.82058 8.65392 9.16667 9.45833 9.16667H9.75V8.875C9.75 8.39258 10.1426 8 10.625 8H12.375C12.8574 8 13.25 8.39258 13.25 8.875V9.16667H13.5417C14.3461 9.16667 15 9.82058 15 10.625ZM9.16667 10.625V11.5H13.8333V10.625C13.8333 10.4646 13.7021 10.3333 13.5417 10.3333H9.45833C9.29792 10.3333 9.16667 10.4646 9.16667 10.625ZM13.8333 13.8333V12.6667H12.0833V13.25H10.9167V12.6667H9.16667V13.8333H13.8333ZM2.16667 2.75C2.16667 2.428 2.428 2.16667 2.75 2.16667H8.58333C8.90533 2.16667 9.16667 2.428 9.16667 2.75V7.45458C9.4735 7.13958 9.87775 6.92083 10.3333 6.8555V2.75C10.3333 1.78517 9.54817 1 8.58333 1H2.75C1.78517 1 1 1.78517 1 2.75V15H6.83333V13.8333H2.16667V2.75ZM5.08333 8.58333H3.33333V9.75H5.08333V8.58333ZM3.33333 12.0833H5.08333V10.9167H3.33333V12.0833ZM5.08333 3.91667H3.33333V5.08333H5.08333V3.91667ZM8 3.91667H6.25V5.08333H8V3.91667ZM5.08333 6.25H3.33333V7.41667H5.08333V6.25ZM6.25 7.41667H8V6.25H6.25V7.41667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6546_26235">
        <rect width="14" height="14" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);
